// extracted by mini-css-extract-plugin
module.exports = {"notes":"TermsAndConditionsCard_notes__132Pj","notesText":"TermsAndConditionsCard_notesText__T-5xd"};